import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { retry } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
@Injectable({ providedIn: 'root' })
export class DashboardProvider {
  baseUrl: string = environment.API_SERVER;
  constructor(private _http: HttpClient) {}

  getCompanyFinanceRecord(payload) {
    return this._http.post(
      this.baseUrl + `/finance/organizations/enterprise/dashboard-data/`,
      payload.body
    );
  }

  getCurrencyList(payload) {
    return this._http.get(`${this.baseUrl}/finance/config/currencies/`, {
      params: payload.params,
    });
  }

  getCompanyRecord(payload) {
    return this._http.get(this.baseUrl + '/dashboard/company_dashboard/');
  }

  getCompanyDetail(payload = {}) {
    return this._http.get(this.baseUrl + '/dashboard/company_details/');
  }

  getCompanyVerification(payload) {
    return this._http.get(this.baseUrl + '/dashboard/verifications/');
  }
  getCompanyApplication(payload) {
    return this._http.get(this.baseUrl + '/dashboard/applications/');
  }

  getCompanyUser(payload) {
    return this._http.get(this.baseUrl + '/dashboard/users/');
  }

  getStatus(payload) {
    return this._http.get(
      `${this.baseUrl}/change-request/type/organization-status/?organizationId=${payload.organizationId}`
    );
  }
}
